const bigContext = require.context(
  '../../img/gallery/BIG',
  false,
  /\.(jpe?g|png|webp)$/
);
const smallContext = require.context(
  '../../img/gallery/SMALL',
  false,
  /\.(jpe?g|png|webp)$/
);
const videoContext = require.context(
  '../../img/gallery/HOVER_VIDEOS',
  false,
  /\.(mp4|webm)$/
);

const buildGallery = (bigCtx, smallCtx, vidCtx, imageLinks = []) => {
  const keys = bigCtx.keys().sort((a, b) => {
    const numA = parseInt(a.replace('./', ''));
    const numB = parseInt(b.replace('./', ''));
    return numA - numB;
  });

  const combinedGallery = keys.map((key) => {
    const resBig = bigCtx(key);
    const resSmall = smallCtx(key);

    // Look for a video with the same number (e.g., 1.mp4)
    const videoKey = key.replace(/\.[^/.]+$/, '.mp4');
    let hoverVideo = null;
    try {
      const resVideo = vidCtx(videoKey);
      hoverVideo = resVideo.default || resVideo;
    } catch (e) {
      hoverVideo = null;
    }

    return {
      big: resBig.default || resBig,
      small: resSmall.default || resSmall,
      hoverVideo: hoverVideo,
      tipo: 'image',
    };
  });

  const videosToInject = [
    // {
    //   index: 4,
    //   data: {
    //     big: "https://vimeo.com/859900574",
    //     small: "https://vimeo.com/859900574",
    //     tipo: "video",
    //     link
    //   }
    // },
    // {
    //   index: 10,
    //   data: {
    //     big: "https://vimeo.com/853157093",
    //     small: "https://vimeo.com/853157093",
    //     tipo: "video",
    //   }
    // }
  ];

  videosToInject
    .sort((a, b) => b.index - a.index)
    .forEach((vid) => {
      combinedGallery.splice(vid.index, 0, vid.data);
    });

  imageLinks.forEach((item) => {
    if (
      combinedGallery[item.index] &&
      combinedGallery[item.index].tipo === 'image'
    ) {
      combinedGallery[item.index].link = item.link;
    }
  });

  return combinedGallery;
};

// Pass Link here for

const img = buildGallery(bigContext, smallContext, videoContext, [
  { index: 0, link: '/VelaViento' },
  { index: 1, link: '/Granton' },
]);

// For a second gallery variant, create another set of require.context calls
// pointing to a different folder structure, then build it here.
// Example:

const bigContextVelaVientoGallery = require.context(
  '../../img/VelaViento/BIG',
  false,
  /\.(jpe?g|png|webp)$/
);
const smallContextVelaVientoGallery = require.context(
  '../../img/VelaViento/SMALL',
  false,
  /\.(jpe?g|png|webp)$/
);
const videoContextVelaVientoGallery = require.context(
  '../../img/VelaViento/HOVER_VIDEOS',
  false,
  /\.(mp4|webm)$/
);

const imgVelaVientoAlternate = buildGallery(
  bigContextVelaVientoGallery,
  smallContextVelaVientoGallery,
  videoContextVelaVientoGallery
);

const bigContextGrantonGallery = require.context(
  '../../img/Granton/BIG',
  false,
  /\.(jpe?g|png|webp)$/
);
const smallContextGrantonGallery = require.context(
  '../../img/Granton/SMALL',
  false,
  /\.(jpe?g|png|webp)$/
);
const videoContextGrantonGallery = require.context(
  '../../img/Granton/HOVER_VIDEOS',
  false,
  /\.(mp4|webm)$/
);

const imgGrantonGallery = buildGallery(
  bigContextGrantonGallery,
  smallContextGrantonGallery,
  videoContextGrantonGallery
);

// placeholder variant using same folder

const galleryVariants = {
  default: img,
  alternate: imgVelaVientoAlternate,
  granton: imgGrantonGallery,
};

export const getGalleryImages = (variant = 'default') => {
  return galleryVariants[variant] || galleryVariants.default;
};

export { img }; // keep default export for backwards compatibility
